"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const helpers_1 = require("./helpers");
const components_1 = require("../components");
/**
 * Creates a new stasis HOC that can be easily composed.
 * @param onError The optional callback when an error is emitted.
 * @returns The HOC used for putting the component in a stasis.
 */
function createStasis(onError) {
    return Component => withStasis(Component, onError);
}
exports.createStasis = createStasis;
/**
 * Creates a new stasis field that can be placed around components.
 * @param Component The component that is rendered in case of an error.
 * @param onError The optional callback when an error is emitted.
 */
function withStasis(Component, onError) {
    const Wrapper = props => (React.createElement(components_1.ArbiterStasis, { onError: onError, renderError: error => React.createElement(Component, Object.assign({ error: error }, props, { children: undefined })) }, props.children));
    Wrapper.displayName = `WithStasis(${helpers_1.getDisplayName(Component)})`;
    return Wrapper;
}
exports.withStasis = withStasis;
